import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const IMAGE = 'image'
export const VIDEO = 'video'
export const CHOOSE_PICTURE = 'choose picture'
export const NO_IMAGE = 'no image'
export const DELETE = 'delete'
export const APPLY = 'apply'
export const LOADING = 'loading'
export const NO_VIDEO = 'no video'
export const MESSAGE_REQUEST_ERROR = 'message request error'
export const PREVIEW = 'preview'
export const GROUP_ADVANCED_SETTINGS = 'group advanced settings'
export const DEFAULT_SWITCH = 'default switch'
export const UPLOAD = 'upload'
export const DISPLAY_LABEL = 'addLabelOption'

export default {
  [PORTUGUESE]: {
    [IMAGE]: 'Imagem',
    [VIDEO]: 'Vídeo',
    [CHOOSE_PICTURE]:
      'Escolha a sua mídia clicando em "upload" e depois ajuste a mídia para o tamanho que você deseja movendo o controle deslizante acima.',
    [NO_IMAGE]: 'Sem Imagem',
    [DELETE]: 'Excluir',
    [APPLY]: 'Aplicar',
    [LOADING]: 'carregando',
    [NO_VIDEO]: 'Nenhum vídeo',
    [MESSAGE_REQUEST_ERROR]: 'Algo deu errado',
    [PREVIEW]: 'Visualizar',
    [GROUP_ADVANCED_SETTINGS]: 'Configurações Avançadas do Grupo',
    [DEFAULT_SWITCH]: 'não é um tipo válido',
    [UPLOAD]: 'Adicionar Mídia',
    [DISPLAY_LABEL]: 'Mostrar texto da alternativa',
  },

  [ENGLISH]: {
    [IMAGE]: 'Image',
    [VIDEO]: 'Video',
    [CHOOSE_PICTURE]:
      'Choose your media clicking on "upload" and then adjust the media to the size you want by moving the slider above.',
    [NO_IMAGE]: 'No Image',
    [DELETE]: 'Delete',
    [APPLY]: 'Apply',
    [LOADING]: 'loading',
    [NO_VIDEO]: 'No Video',
    [MESSAGE_REQUEST_ERROR]: 'Something went wrong',
    [PREVIEW]: 'Preview',
    [GROUP_ADVANCED_SETTINGS]: 'Group Advanced Settings',
    [DEFAULT_SWITCH]: 'is not a valid type',
    [UPLOAD]: 'Upload',
    [DISPLAY_LABEL]: 'Show alternative label',
  },

  [SPANISH]: {
    [IMAGE]: 'Imagen',
    [VIDEO]: 'Video',
    [CHOOSE_PICTURE]:
      'Elija su medios haciendo clic en "cargar" y luego ajuste la medios al tamaño desea moviendo el control deslizante de arriba.',
    [NO_IMAGE]: 'Sin Imágen',
    [DELETE]: 'Borrar',
    [APPLY]: 'Aplicar',
    [LOADING]: 'cargando',
    [NO_VIDEO]: 'No hay video',
    [MESSAGE_REQUEST_ERROR]: 'Algo salió mal',
    [PREVIEW]: 'Vista previa',
    [GROUP_ADVANCED_SETTINGS]: 'Configuración Avanzada del Grupo',
    [DEFAULT_SWITCH]: 'no es un tipo valido',
    [UPLOAD]: 'Agregar Midia',
    [DISPLAY_LABEL]: 'Show alternative label',
  },
}
